import { render, staticRenderFns } from "./stage2final.vue?vue&type=template&id=654ff01a&"
import script from "./stage2final.vue?vue&type=script&lang=js&"
export * from "./stage2final.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports